module.exports = __webpack_public_path__ + "static/media/microsoftWord.113ac212.svg";